export const fullName = (user) => {
  const { first_name, last_name } = user;
  return [first_name, last_name].filter((n) => n).join(" ");
};
